<script>
    let { yScale,
        ticks = [-2, -1.5, -1, -0.5, 0, 0.5, 1, 1.5, 2, 2.5, 3], 
        chartwidth = 400,
        width = 600
     } = $props();

    const topTick = $derived(Math.max(...ticks));

    // Drop the descriptive text labels on mobile to save horizontal space,
    // keeping just the numeric values.
    const isMobile = $derived(width < 450);

    const label = tick => {
        let s = tick > 0 ? `+${tick}` : `${tick}`;
        if (tick === topTick) s += '°C';
        if (!isMobile) {
            if (tick === 2) s += ': Very strong ("Super")';
            if (tick === 1.5) s += ': Strong';
        }
        return s;
    };
</script>
<g class="y-axis">
   
    {#each ticks as tick, i}
        {@const strong = tick === 1.5 || tick === 2 || tick === topTick}
        {#if tick % 1 === 0 || tick === 1.5}
            
            <text x=0 y={yScale(tick) - 4} class="tick-text" class:strong>{label(tick)}</text>
        {/if}
        
        <line class="y-tick" class:zero={tick === 0} class:nino={tick > 0.5} class:threshold={tick === 0.5} class:strong
            x1={0} 
            x2={chartwidth} 
            y1={yScale(tick)} y2={yScale(tick)} 
        >
        </line>
    {/each}
    
</g>
<style lang='scss'>
    .tick-text {
        font-size: 12px;
        fill: #666;
        &.strong {
            font-weight: 700;
            fill: $red;
            // font-size: 
        }
    }
    .y-tick {
        stroke: #999;
        &.zero {
            stroke: #333;
            stroke-width: 1.5;
        }
        &.nino {
            stroke: #ffffff;
        }
        &.threshold {
            stroke: $red;
        }
        &.strong {
            fill: $red;
        }
    }
</style>